import { MainButton } from '@vkruglikov/react-telegram-web-app';
import { useTelegram } from '../../contexts/TelegramContext';
import { MainButtonFallback, MainButtonStyled } from './AdaptiveMainButton.styles';

export interface AdaptiveMainButtonProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  progress?: boolean;
  color?: string;
  textColor?: string;
}

export function AdaptiveMainButton({
  text,
  onClick,
  disabled = false,
  progress = false,
  color,
  textColor,
}: AdaptiveMainButtonProps) {
  const { isTelegram } = useTelegram();

  if (isTelegram) {
    return (
      <MainButton
        text={text}
        onClick={onClick}
        disabled={disabled || progress}
        progress={progress}
        color={color}
        textColor={textColor}
      />
    );
  }

  return (
    <MainButtonFallback>
      <MainButtonStyled
        variant="filled"
        onClick={(e) => {
          e.preventDefault();
          onClick?.();
        }}
        disabled={disabled || progress}
        isLoading={progress}
      >
        {text}
      </MainButtonStyled>
    </MainButtonFallback>
  );
}
